/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![SettingsPlusIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB10lEQVR4nM1VO04DQQyNoOYvEFRcAThFBDu2F+TYCSAqOACfOncAwXlIEB1UgETNp+MACRIfeUmizbCTXQIFI1lazXj8vM/2m1LpPyxmHgWSWyBtmTnSO9v7MwDEnUkg/UgbM08MFWx1vbboSJuOZK+7F8WVFR8AsbbUPTdfR9qwuwWCy3MnyDugnkFcUUC99gEcyVXn7Czx/dp/GghiWfiB4KeGch4EANLdVDY/NofyZjEG0gQkp8P/gRyX8haiyHe+9SHC6gYAjJlFWCVHep/hV8kMaj29tlabAtBlv6CO9IGZp/075m9nfuGt4+ysb05scEK/HWF1I0hnLDyArtt0cVtBR4CxEEC5vDk+oCatXwMw84RDbTvUgzjeXFhlno9QDh3KqweQ6EyIIgoBWFGBZP8bdSRHgHqTWeRkQvuLfG9nfhCi7RmH8hjHW3MdsEtAubDver0+EhTDZPwz2hRiYePczDK34A7lJUVz4hv628KD5lDbRkuZebb/XgEAU8U8qXCoB9mJFQLIF7tyJ/OE83zhS2rSWya1Jrk94UI9Me7The8C2OVc8SNthh6cRloVwSSk17ZyODRFRZ5MlwyRHFkr/hmA/+jbEPl9/iuAIstqksX5J8T9GeSkZ1LoAAAAAElFTkSuQmCC)
 */
export const SettingsPlusIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M10.56 1.1c-.46.05-.7.53-.64.98.18 1.16-.19 2.2-.98 2.53-.8.33-1.79-.15-2.49-1.1-.27-.36-.78-.52-1.14-.24-.77.59-1.45 1.27-2.04 2.04-.28.36-.12.87.24 1.14.96.7 1.43 1.7 1.1 2.49-.33.8-1.37 1.16-2.53.98-.45-.07-.93.18-.99.64a11.1 11.1 0 0 0 0 2.88c.06.46.54.7.99.64 1.16-.18 2.2.19 2.53.98.33.8-.14 1.79-1.1 2.49-.36.27-.52.78-.24 1.14.59.77 1.27 1.45 2.04 2.04.36.28.87.12 1.14-.24.7-.95 1.7-1.43 2.49-1.1.8.33 1.16 1.37.98 2.53-.07.45.19.93.64.99a11.1 11.1 0 0 0 2.88 0c.46-.06.7-.54.64-.99a.12.12 0 0 0-.08-.09A3 3 0 0 1 15 16h.5a.5.5 0 0 0 .5-.5V15a3 3 0 0 1 5.83-1c.01.04.05.07.1.08.44.07.92-.18.98-.64a11.1 11.1 0 0 0 0-2.88c-.06-.46-.54-.7-.99-.64-1.16.18-2.2-.19-2.53-.98-.33-.8.15-1.79 1.1-2.49.36-.27.52-.78.24-1.14a11.07 11.07 0 0 0-2.04-2.04c-.36-.28-.87-.12-1.14.24-.7.96-1.7 1.43-2.49 1.1-.8-.33-1.16-1.37-.98-2.53.07-.45-.18-.93-.64-.99a11.1 11.1 0 0 0-2.88 0ZM16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19 14a1 1 0 0 1 1 1v3h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3h-3a1 1 0 1 1 0-2h3v-3a1 1 0 0 1 1-1Z"
        className={colorClass}
      />
    </svg>
  );
};
